<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/styles/font-awesome-4.7.0/css/font-awesome.min.css';
.desktop {
  display: none;
  overflow: hidden;
}
.mobile {
  display: block;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  font-size: 1rem;
}
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.start-gradient {
  background: linear-gradient(135deg, #fd9b8e 0%, #ff0846 100%);
}
@media screen and (min-width: 500px) {
  .desktop {
    display: block;
  }
  .start-gradient {
    background: linear-gradient(180deg, #fd9b8e 0%, #ff0846 100%);
  }
  .mobile {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue